export const PERMISSION_CHAT = 'chat:m';
export const PERMISSION_FAVOURITES = 'favourites:m';
export const PERMISSION_NOTES = 'notes:m';
export const PERMISSION_PRODUCTPDF = 'productpdf:r';
export const PERMISSION_PRODUCT = 'productdetail:r';
export const PERMISSION_FILTERS = 'filters:r';
export const PERMISSION_BCARD = 'bcard:r';
